import { useNavigate } from 'react-router-dom';

const useRedirection = () => {
	const navigate = useNavigate();

	const userRedirection = (redirectURLFromQueryString: any) => {
		const isFullRedirectURL = /\bhttps?:\/\/\S+/gi.test(redirectURLFromQueryString);

		if (redirectURLFromQueryString && !isFullRedirectURL) {
			setTimeout(() => {
				window.location.href = window.location.origin + redirectURLFromQueryString;
			}, 500);
		} else if (isFullRedirectURL) {
			const redirectURL = new URL(redirectURLFromQueryString);
			const referrerURL = document.referrer && new URL(document.referrer);

			if (
				redirectURL &&
				redirectURL.protocol === 'https:' &&
				/vizio.com/.test(redirectURL.hostname)
			) {
				if (referrerURL) {
					if (referrerURL.protocol === 'https:' && /vizio.com/.test(referrerURL.hostname)) {
						setTimeout(() => {
							window.location.href = redirectURLFromQueryString;
						}, 500);
					} else {
						navigate('/');
					}
				} else {
					setTimeout(() => {
						window.location.href = redirectURLFromQueryString;
					}, 500);
				}
			} else {
				navigate('/');
			}
		} else {
			navigate('/');
		}
	};

	return [userRedirection];
};

export default useRedirection;
